const CartIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.31191 3.63796C8.66697 3.24282 9.25286 2.99999 10.0003 3C10.7471 3.00001 11.333 3.24282 11.6881 3.63802C11.9662 3.9475 12.1258 4.39341 12.1774 5H7.8229C7.87415 4.3934 8.03381 3.94745 8.31191 3.63796ZM6.81999 5C6.87364 4.23059 7.07656 3.51659 7.56809 2.96958C8.15937 2.31157 9.04714 1.99999 10.0003 2C10.9529 2.00001 11.8407 2.31166 12.4319 2.96965C12.9234 3.51666 13.1263 4.23068 13.1804 5H15.5293C16.0843 5 16.5603 5.43328 16.5666 6.00578L16.9996 16.963C16.9997 16.9656 16.9998 16.9682 16.9999 16.9708C17 16.9748 17 16.9788 17 16.9828C17 17.5661 16.5116 18 15.9583 18H4.04167C3.48836 18 3 17.5661 3 16.9828C3 16.9762 3.00013 16.9696 3.00039 16.963L3.4334 6.00576C3.43982 5.42334 3.9349 5 4.47933 5H6.81999ZM12.6963 6C12.6961 6 12.6959 6 12.6957 6H4.47933C4.45976 6 4.44547 6.00744 4.43747 6.015C4.43531 6.01704 4.43402 6.0187 4.43333 6.01973L4.43294 6.03698L4.00039 16.9827C4.00101 16.9837 4.00211 16.9851 4.00396 16.9869C4.01036 16.993 4.02263 17 4.04167 17H15.9583C15.9774 17 15.9896 16.993 15.996 16.9869C15.9979 16.9851 15.999 16.9837 15.9996 16.9827L15.5671 6.03698C15.5668 6.03041 15.5667 6.02382 15.5667 6.01724C15.5667 6.01614 15.5666 6.01597 15.5665 6.0159L15.5665 6.01588C15.5663 6.01546 15.5654 6.01365 15.5629 6.01119C15.5581 6.00654 15.5478 6 15.5293 6H12.6963Z"
      fill="currentColor"
    />
  </svg>
);

export { CartIcon };
